import React from 'react';
import styled from 'styled-components';
import { SectionParent, B1, H1, H2 } from '../../StyledComponents';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import EsperMissionEN from '../../../assets/v2/AboutUs/EsperMission.en.svg';
import EsperMissionDE from '../../../assets/v2/AboutUs/EsperMission.de.svg';

const Section = styled(SectionParent)`
  background: #ffffff;
  padding-top: 1rem !important;
  padding-bottom: 0rem !important;
  @media (max-width: 520px) {
    padding-top: 1rem !important;
    padding-bottom: 0rem !important;
  }
`;
const Grid = styled.div`
  display: grid;
  padding-bottom: 3rem;
  padding-top: 2rem;
  grid-template-columns: repeat(4, 1fr);
  @media (max-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: 700px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;
const GridItem = styled.div`
  justify-self: center;
  max-width: 60%;
  grid-column: span 4;
  @media (max-width: 768px) {
    margin-right: 0rem;
  }
  /* @media (max-width: 700px) {
    grid-column: span 3;
    margin-bottom: 3rem;
    display: grid;
    margin-right: 0rem;
    justify-items: center;
  } */
  @media (max-width: 520px) {
    max-width: 90%;
  }
`;
const SectionContent = styled(B1)`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.61;
  letter-spacing: normal;
  width: 100%;
  color: #626679;
  padding-top: 0.5rem;
  text-align: justify;
  img {
    margin-top: 1rem;
  }
  /* @media (max-width: 700px) {
    padding-left: 0;
    text-align: justify;
    width: 90%;
  }
  @media (max-width: 520px) {
    width: 120%;
    text-align: center;
  } */
`;
const SectionTitle = styled(H1)`
  @media (max-width: 520px) {
    text-align: center;
  }

  font-weight: bold;
  font-family: 'Nunito Sans', sans-serif;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.92;
  letter-spacing: normal;
  color: #151828;
`;

const SectionTopTitle = styled(H2)`
  color: #151828;
  font-family: 'Nunito Sans', sans-serif;
  font-weight: bold;
`;

const TargetImage = styled(LazyLoadImage)`
  width: 100%;
  margin: 3rem 0;
  justify-self: center;
`;
const ImgWrapper = styled.div`
  display: grid;
  align-items: center;
  grid-column: span 4;
  @media (max-width: 768px) {
    grid-column: span 4;
  }
  @media (max-width: 700px) {
    grid-column: span 3;
  }
  @media (max-width: 520px) {
    padding-bottom: 2rem;
  }
`;
export default ({ messages }: any) => (
  <div>
    <Section>
      <Grid>
        <GridItem>
          <SectionTopTitle>{messages?.AboutUsPageValues}</SectionTopTitle>
          <SectionTitle>{messages?.AboutUsPageMissionTitle}</SectionTitle>
          <SectionContent> {messages?.AboutUsPageMissionDesc1}</SectionContent>
          <ImgWrapper>
            <TargetImage
              src={messages?.locale !== 'en' ? EsperMissionDE : EsperMissionEN}
            />
          </ImgWrapper>
          <SectionContent>
            {messages?.AboutUsPageMissionDesc2}
            <br />
            <br />
            {messages?.AboutUsPageMissionDesc3}
          </SectionContent>
        </GridItem>
      </Grid>
    </Section>
  </div>
);
